import styled from 'styled-components';
// Components
import {
    AddressSearch,
    Divider,
    LocationButton,
    LocationButtonGroup,
    LocationDropdown,
    LocationSearch,
    MiniDivider,
    RichText,
    Title,
} from 'components/bos-modules';
import ClaimPOSTabPage from 'pages/ClaimPOSTab/ClaimPOSTabPage';
import Page from 'pages/Page';
import { Col, Row } from 'top-component-library';

// Constants
import breakpoints from 'constants/breakpoints';
import { footer, header } from 'constants/style';

export const LegacyPage = styled(Page)`
  position: relative;

  main {
    position: initial;
  }
`;

export const FullHeightRow = styled(Row)`
  background-color: transparent;
  display: flex;
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
  margin: 0 auto;
  max-width: 100%;
  padding-left: 2rem;
  padding-right: 2rem;
  position: relative;
  text-align: var(--content-align);
  z-index: 1;

  @media (min-width: ${breakpoints.xs}px) {
    max-width: 30rem;
  }

  @media (min-width: ${breakpoints.md}px) {
    margin: initial;
    max-width: initial;

    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }
`;

export const FullHeightColumn = styled.div`
  display: flex;
  flex-basis: auto;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  justify-content: center;
  max-width: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;

  > *:not(:last-child) {
    margin-bottom: 2rem;
  }

  @media (min-width: ${breakpoints.md}px) {
    max-width: 50%;
    margin-left: ${(props) => (props.centered ? 'auto' : '0px')};
    margin-right: ${(props) => (props.centered ? 'auto' : '0px')};
  }

  @media (min-width: ${breakpoints.lg}px) {
    margin-left: ${(props) => (props.centered ? 'auto' : '5%')};
    max-width: 40%;
  }

  @media (min-width: ${breakpoints.xl}px) {
    margin-left: ${(props) => (props.centered ? 'auto' : '8.888%')};
    max-width: ${(props) => (props.centered ? '600px' : '33.333%')};
  }

  @media (min-width: ${breakpoints.xxl}px) {
    margin-left: ${(props) => (props.centered ? 'auto' : 'calc(8.888% - 1.75rem)')};
  }
`;

export const LandingPageImageContainer = styled.div`
  background-color: var(--color-secondary__regular);
  display: block;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: auto;

  &[data-has-image='1'] {
    // Change dimming on landing page image
    filter: var(--bose-landing-image__brightness);
  }

  @media (min-width: ${breakpoints.md}px) {
    height: calc(100% + ${header.desktop.height}px + ${footer.desktop.height}px);
    top: -${header.desktop.height}px;
  }
`;

// Legacy BOS Modules
export const LegacyTitle = styled(Title)`
  h1 span {
    font-weight: 600;
    text-transform: uppercase;
    color: #ffffff;
  }
`;

export const LegacyRichText = styled(RichText)`
  p,
  p span,
  p span sup,
  p span sub,
  p span sup em,
  p strong,
  * {
    color: #ffffff;
  }

  a {
    text-decoration: underline;
  }
`;

export const LegacyLocationDropdown = styled(LocationDropdown)``;

export const LegacyCateringLocationDropdown = styled(LocationDropdown)``;

export const LegacyLocationSearch = styled(LocationSearch)``;

export const LegacyLocationButton = styled(LocationButton)`
  &.ant-btn[disabled] {
    opacity: 0.6;
    background-color: gray;
    color: #ffffff;
  }
`;

export const LegacyLocationButtonGroup = styled(LocationButtonGroup)`
  &&& {
    .ant-btn[disabled] {
      opacity: 0.6;
      background-color: gray;
      color: #ffffff;
    }
  }
`;

export const LegacyDivider = styled(Divider)`
  .divider {
    span {
      color: #ffffff;
    }

    &:before,
    &:after {
      border-color: #ffffff;
    }
  }
`;

export const LegacyMiniDivider = styled(MiniDivider)``;

export const LegacyAddressSearch = styled(AddressSearch)`
  .address-loading-spinner,
  .no-locations-found {
    border: 1px solid var(--color-neutral__line);
    border-radius: var(--input__border-radius);
    background-color: var(--color-neutral__card-background);
    padding: 0.5rem;
  }

  .no-locations-found {
    opacity: 0.7;

    & > p {
      margin-bottom: 0;
    }
  }
`;

export const ComponentMap = {
  Title: LegacyTitle,
  RichText: LegacyRichText,
  LocationDropdown: LegacyLocationDropdown,
  CateringLocationDropdown: LegacyCateringLocationDropdown,
  LocationSearch: LegacyLocationSearch,
  LocationButton: LegacyLocationButton,
  LocationButtonGroup: LegacyLocationButtonGroup,
  Divider: LegacyDivider,
  MiniDivider: LegacyMiniDivider,
  AddressSearch: LegacyAddressSearch,
  row: Row,
  col: Col,
  ClaimPOSTabPage,
};
